import TextAlign from "@tiptap/extension-text-align";

export const CustomTextAlign = TextAlign.extend({
  addKeyboardShortcuts() {
    return {};
  },
});
